var map = {
	"./australia.svg": 857,
	"./austria.svg": 2054,
	"./bahrain.svg": 1856,
	"./belgium.svg": 9432,
	"./bulgaria.svg": 5954,
	"./canada.svg": 2619,
	"./czech.svg": 6702,
	"./estonia.svg": 4594,
	"./france.svg": 8520,
	"./germany.svg": 6716,
	"./greece.svg": 804,
	"./hungary.svg": 6837,
	"./iceland.svg": 8221,
	"./ireland.svg": 5122,
	"./israel.svg": 1241,
	"./italy.svg": 6898,
	"./japan.svg": 9967,
	"./kuwait.svg": 1874,
	"./latvia.svg": 3464,
	"./lithuania.svg": 5662,
	"./malta.svg": 9328,
	"./netherlands.svg": 9703,
	"./norway.svg": 6567,
	"./oman.svg": 1864,
	"./poland.svg": 7377,
	"./portugal.svg": 9003,
	"./qatar.svg": 3588,
	"./romania.svg": 3074,
	"./saudi.svg": 4787,
	"./slovakia.svg": 3797,
	"./slovenia.svg": 9616,
	"./spain.svg": 9483,
	"./sweden.svg": 5621,
	"./switzerland.svg": 8560,
	"./uae.svg": 7404,
	"./uk.svg": 9681,
	"./usa.svg": 5306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;